/**
 * PM CRM WebSocket live updates
 *
 * Connects to /ws/pm-crm/ on PM CRM pages and refreshes
 * list rows when records are mutated from other tabs/users.
 */

(function () {

    function isOnPmCrmPage() {
        return window.location.pathname.indexOf('/pm-crm/') === 0;
    }

    function refreshRow(elementId, url) {
        var row = document.getElementById(elementId);
        if (!row) return;
        var xhr = new XMLHttpRequest();
        xhr.open('GET', url);
        xhr.setRequestHeader('HX-Request', 'true');
        xhr.onload = function () {
            if (xhr.status >= 200 && xhr.status < 300 && xhr.responseText.trim()) {
                var parent = row.parentNode;
                if (!parent) return;
                row.outerHTML = xhr.responseText;
                if (window.htmx) htmx.process(parent);
            }
        };
        xhr.send();
    }

    function refreshLeadRow(leadId) {
        var stage = new URLSearchParams(window.location.search).get('stage') || '';
        var url = '/pm-crm/leads/' + leadId + '/row/';
        if (stage) url += '?stage=' + encodeURIComponent(stage);
        refreshRow('lead-' + leadId, url);
    }

    function removeRow(row) {
        if (!row) return;
        var tbody = row.closest('tbody');
        row.remove();
        if (tbody && !tbody.querySelector('tr')) {
            var colCount = tbody.closest('table').querySelectorAll('thead th').length || 4;
            tbody.insertAdjacentHTML('beforeend',
                '<tr><td colspan="' + colCount + '" class="data-table__empty">No results found</td></tr>');
        }
    }

    function removeLeadRow(leadId) {
        removeRow(document.getElementById('lead-' + leadId));
    }

    function refreshEmailThreadRow(threadId) {
        refreshRow('thread-' + threadId, '/pm-crm/emails/' + threadId + '/row/');
    }

    function isOnPropertyList() {
        return window.location.pathname === '/pm-crm/properties/';
    }

    function refreshPropertyRow(propertyId) {
        refreshRow('property-' + propertyId, '/pm-crm/properties/' + propertyId + '/row/');
    }

    function removePropertyRow(propertyId) {
        removeRow(document.getElementById('property-' + propertyId));
    }

    function isOnOwnerList() {
        return window.location.pathname === '/pm-crm/owners/';
    }

    function refreshOwnerRow(ownerId) {
        refreshRow('owner-' + ownerId, '/pm-crm/owners/' + ownerId + '/row/');
    }

    function removeOwnerRow(ownerId) {
        removeRow(document.getElementById('owner-' + ownerId));
    }

    function isOnProspectList() {
        return window.location.pathname.indexOf('/prospects/') !== -1;
    }

    function isOnAffiliateList() {
        return window.location.pathname === '/pm-crm/affiliates/';
    }

    function refreshAffiliateRow(affiliateId) {
        refreshRow('affiliate-' + affiliateId, '/pm-crm/affiliates/' + affiliateId + '/row/');
    }

    function removeAffiliateRow(affiliateId) {
        removeRow(document.getElementById('affiliate-' + affiliateId));
    }

    function isOnFirmList() {
        return window.location.pathname === '/pm-crm/firms/';
    }

    function isOnFirmProspectList() {
        return window.location.pathname === '/pm-crm/firm-prospects/';
    }

    function isOnFirmLeadList() {
        return window.location.pathname === '/pm-crm/firm-leads/';
    }

    function refreshFirmProspectRow(firmLeadId) {
        refreshRow('firm-prospect-' + firmLeadId, '/pm-crm/firm-prospects/' + firmLeadId + '/row/');
    }

    function removeFirmProspectRow(firmLeadId) {
        removeRow(document.getElementById('firm-prospect-' + firmLeadId));
    }

    function refreshFirmLeadRow(firmLeadId) {
        refreshRow('firm-lead-' + firmLeadId, '/pm-crm/firm-leads/' + firmLeadId + '/row/');
    }

    function removeFirmLeadRow(firmLeadId) {
        removeRow(document.getElementById('firm-lead-' + firmLeadId));
    }

    function refreshFirmRow(firmId) {
        refreshRow('firm-' + firmId, '/pm-crm/firms/' + firmId + '/row/');
    }

    function removeFirmRow(firmId) {
        removeRow(document.getElementById('firm-' + firmId));
    }

    function refreshProspectRow(prospectId) {
        var stage = new URLSearchParams(window.location.search).get('stage') || '';
        var url = '/pm-crm/prospects/' + prospectId + '/row/';
        if (stage) url += '?stage=' + encodeURIComponent(stage);
        refreshRow('prospect-' + prospectId, url);
    }

    function removeProspectRow(prospectId) {
        removeRow(document.getElementById('prospect-' + prospectId));
    }

    function isOnContactList() {
        return window.location.pathname === '/pm-crm/contacts/';
    }

    function refreshContactRow(contactId) {
        refreshRow('contact-' + contactId, '/pm-crm/contacts/' + contactId + '/row/');
    }

    function removeContactRow(contactId) {
        removeRow(document.getElementById('contact-' + contactId));
    }

    function isOnClientList() {
        return location.pathname === '/pm-crm/clients/';
    }

    function refreshClientRow(clientId) {
        refreshRow('client-' + clientId, '/pm-crm/clients/' + clientId + '/row/');
    }

    function removeClientRow(clientId) {
        removeRow(document.getElementById('client-' + clientId));
    }

    var reloadTimer = null;
    function debouncedReload() {
        if (reloadTimer) clearTimeout(reloadTimer);
        reloadTimer = setTimeout(function () { window.location.reload(); }, 2000);
    }

    function isOnLeadList() {
        var p = window.location.pathname;
        return p === '/pm-crm/' || p === '/pm-crm/leads/';
    }

    function isOnEmailList() {
        return window.location.pathname === '/pm-crm/emails/';
    }

    function refreshEntityEmailCard(contactId) {
        // Refresh any email card on the page whose data-email-contact matches
        if (!contactId) return;
        var card = document.querySelector('[data-email-contact="' + contactId + '"]');
        if (card) htmx.trigger(card, 'emailSynced');
    }

    // --- WebSocket connection ---

    var socket = null;
    var reconnectTimer = null;
    var reconnectAttempts = 0;

    function connect() {
        if (reconnectTimer) { clearTimeout(reconnectTimer); reconnectTimer = null; }

        var protocol = location.protocol === 'https:' ? 'wss:' : 'ws:';
        socket = new WebSocket(protocol + '//' + location.host + '/ws/pm-crm/');

        socket.onopen = function () {
            reconnectAttempts = 0;
        };

        socket.onmessage = function (e) {
            var data = JSON.parse(e.data);

            if (data.type === 'lead_updated') {
                if (isOnLeadList()) refreshLeadRow(data.lead_id);

            } else if (data.type === 'lead_created') {
                if (isOnLeadList()) debouncedReload();

            } else if (data.type === 'lead_deleted') {
                if (isOnLeadList()) removeLeadRow(data.lead_id);

            } else if (data.type === 'email_synced') {
                if (isOnLeadList() && data.lead_id) refreshLeadRow(data.lead_id);
                if (isOnEmailList()) debouncedReload();
                // Refresh any open email card that matches this contact
                refreshEntityEmailCard(data.contact_id);

            } else if (data.type === 'thread_read') {
                if (isOnLeadList() && data.lead_id) refreshLeadRow(data.lead_id);
                if (isOnEmailList() && data.thread_id) refreshEmailThreadRow(data.thread_id);

            } else if (data.type === 'proposal_updated') {
                if (isOnLeadList() && data.lead_id) refreshLeadRow(data.lead_id);

            } else if (data.type === 'property_updated') {
                // No rfSheet.refresh() — every field edit broadcasts this, and a full
                // sheet refresh blows away the targeted partial swap the originating
                // tab just received (and clobbers in-progress edits in any other tab).
                if (isOnPropertyList()) refreshPropertyRow(data.property_id);

            } else if (data.type === 'property_created') {
                if (isOnPropertyList()) debouncedReload();

            } else if (data.type === 'property_deleted') {
                if (isOnPropertyList()) removePropertyRow(data.property_id);

            } else if (data.type === 'owner_updated') {
                if (isOnOwnerList()) refreshOwnerRow(data.owner_id);

            } else if (data.type === 'owner_created') {
                if (isOnOwnerList()) debouncedReload();

            } else if (data.type === 'owner_deleted') {
                if (isOnOwnerList()) removeOwnerRow(data.owner_id);
                var sheetParam = new URLSearchParams(window.location.search).get('sheet') || '';
                if (sheetParam.indexOf('/owners/' + data.owner_id + '/') !== -1 && window.rfSheet) {
                    window.rfSheet.close();
                }

            } else if (data.type === 'prospect_updated') {
                if (isOnProspectList()) refreshProspectRow(data.prospect_id);

            } else if (data.type === 'prospect_created') {
                if (isOnProspectList()) debouncedReload();

            } else if (data.type === 'prospect_deleted') {
                if (isOnProspectList()) removeProspectRow(data.prospect_id);
                // If prospect's sheet is open, close it
                var sheetParam = new URLSearchParams(window.location.search).get('sheet') || '';
                if (sheetParam.indexOf('/prospects/' + data.prospect_id + '/') !== -1 && window.rfSheet) {
                    window.rfSheet.close();
                }

            } else if (data.type === 'affiliate_updated') {
                if (isOnAffiliateList()) refreshAffiliateRow(data.affiliate_id);

            } else if (data.type === 'affiliate_created') {
                if (isOnAffiliateList()) debouncedReload();

            } else if (data.type === 'affiliate_deleted') {
                if (isOnAffiliateList()) removeAffiliateRow(data.affiliate_id);
                var sheetParam = new URLSearchParams(window.location.search).get('sheet') || '';
                if (sheetParam.indexOf('/affiliates/' + data.affiliate_id + '/') !== -1 && window.rfSheet) {
                    window.rfSheet.close();
                }

            } else if (data.type === 'firm_updated') {
                if (isOnFirmList()) refreshFirmRow(data.firm_id);

            } else if (data.type === 'firm_created') {
                if (isOnFirmList()) debouncedReload();

            } else if (data.type === 'firm_deleted') {
                if (isOnFirmList()) removeFirmRow(data.firm_id);
                var sheetParam = new URLSearchParams(window.location.search).get('sheet') || '';
                if (sheetParam.indexOf('/firms/' + data.firm_id + '/') !== -1 && window.rfSheet) {
                    window.rfSheet.close();
                }

            } else if (data.type === 'firm_lead_updated') {
                if (isOnFirmProspectList()) refreshFirmProspectRow(data.firm_lead_id);
                if (isOnFirmLeadList()) refreshFirmLeadRow(data.firm_lead_id);

            } else if (data.type === 'firm_lead_created') {
                if (isOnFirmProspectList()) debouncedReload();
                if (isOnFirmLeadList()) debouncedReload();

            } else if (data.type === 'firm_lead_deleted') {
                if (isOnFirmProspectList()) removeFirmProspectRow(data.firm_lead_id);
                if (isOnFirmLeadList()) removeFirmLeadRow(data.firm_lead_id);
                var sheetParam = new URLSearchParams(window.location.search).get('sheet') || '';
                if ((sheetParam.indexOf('/firm-prospects/' + data.firm_lead_id + '/') !== -1 ||
                     sheetParam.indexOf('/firm-leads/' + data.firm_lead_id + '/') !== -1) && window.rfSheet) {
                    window.rfSheet.close();
                }

            } else if (data.type === 'contact_updated') {
                if (isOnContactList()) refreshContactRow(data.contact_id);

            } else if (data.type === 'contact_created') {
                if (isOnContactList()) debouncedReload();

            } else if (data.type === 'contact_deleted') {
                if (isOnContactList()) removeContactRow(data.contact_id);
                var sheetParam = new URLSearchParams(window.location.search).get('sheet') || '';
                if (sheetParam.indexOf('/contacts/' + data.contact_id + '/') !== -1 && window.rfSheet) {
                    window.rfSheet.close();
                }

            } else if (data.type === 'client_updated') {
                if (isOnClientList()) refreshClientRow(data.client_id);

            } else if (data.type === 'client_created') {
                if (isOnClientList()) debouncedReload();

            } else if (data.type === 'client_deleted') {
                if (isOnClientList()) removeClientRow(data.client_id);
                var sheetParam = new URLSearchParams(window.location.search).get('sheet') || '';
                if (sheetParam.indexOf('/clients/' + data.client_id + '/') !== -1 && window.rfSheet) {
                    window.rfSheet.close();
                }
            }
        };

        socket.onclose = function (e) {
            socket = null;
            if (e.code === 4401) {
                window.location.href = '/login/?next=' + encodeURIComponent(window.location.pathname);
                return;
            }
            // Don't reconnect if we navigated away from PM CRM
            if (!isOnPmCrmPage()) return;
            // Reconnect with exponential backoff (max 10 attempts, cap at 30s)
            if (reconnectAttempts < 10) {
                var delay = Math.min(2000 * Math.pow(1.5, reconnectAttempts), 30000);
                reconnectAttempts++;
                reconnectTimer = setTimeout(connect, delay);
            }
        };
    }

    if (isOnPmCrmPage()) connect();

    // Reconnect on SPA navigation — pushedIntoHistory fires after the URL is
    // updated, so window.location.pathname is guaranteed correct.
    function checkConnection() {
        if (isOnPmCrmPage() && !socket) {
            reconnectAttempts = 0;
            connect();
        } else if (!isOnPmCrmPage() && socket) {
            socket.close();
            socket = null;
            if (reconnectTimer) { clearTimeout(reconnectTimer); reconnectTimer = null; }
        }
    }
    document.body.addEventListener('htmx:pushedIntoHistory', checkConnection);
    window.addEventListener('popstate', checkConnection);

})();
